import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../layout/service/user.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    standalone: true,
    selector: 'app-quiz',
    imports: [
        CommonModule, 
        DialogModule, 
        ButtonModule, 
        RadioButtonModule, 
        FormsModule
    ],
    template: `
    <!-- Header Section -->
    <div class="quiz-header mb-2">
        <div class="flex flex-column lg:flex lg:justify-between lg:items-center">
            <div class="header-title">
                <h1 class="font-bold text-900 mb-2 flex items-center">
                    <div class="title-icon mr-3">
                        <i class="pi pi-graduation-cap" style="font-size: 2rem"></i>
                    </div>
                    Quiz Center
                </h1>
                <p class="text-600 text-lg m-0">Kumpulan quiz untuk meningkatkan pemahaman Anda</p>
            </div>
        </div>
    </div>

    <!-- Quiz Grid -->
    <div class="quiz-grid" *ngIf="forms.length > 0; else noQuizzes">
        <div class="quiz-item" *ngFor="let form of forms; let i = index">
            <div class="quiz-card" [ngClass]="getCardClass(i)">
                <!-- Card Header -->
                <div class="card-header">
                    <div class="quiz-badge">
                        <img [src]="getIcon(i)"/>
                    </div>
                    <div class="card-actions">
                        <button (click)="showQuizInfo(form)" title="Info Quiz">
                            <i class="pi pi-info-circle" style="font-size: 1.2rem;"></i>
                        </button>
                    </div>
                </div>

                <!-- Card Content -->
                <div class="card-content">
                    <h3 class="quiz-title">{{ form.name }}</h3>
                    <p class="quiz-description">
                        {{ form.description || 'Quiz interaktif untuk menguji pemahaman Anda dalam materi ini.' }}
                    </p>
                    
                    <!-- Quiz Stats -->
                    <div class="quiz-meta">
                        <div class="meta-item">
                            <i class="pi pi-file-edit"></i>
                            <span>{{ form.cases?.length || 0 }} Kasus</span>
                        </div>
                        <div class="meta-item">
                            <i class="pi pi-clock"></i>
                            <span>{{ getEstimatedTime(form.cases?.length || 0) }}</span>
                        </div>
                        <div class="meta-item">
                            <i class="pi pi-calendar"></i>
                            <span>{{ form.created_at | date:'dd MMM' }}</span>
                        </div>
                    </div>

                    <!-- Progress Bar (if any) -->
                    <div class="progress-section" *ngIf="getQuizProgress(form.id) > 0">
                        <div class="progress-header">
                            <span class="progress-label">Progress</span>
                            <span class="progress-value">{{ getQuizProgress(form.id) }}%</span>
                        </div>
                        <div class="progress-bar">
                            <div class="progress-fill" [style.width.%]="getQuizProgress(form.id)"></div>
                        </div>
                    </div>
                </div>

                <!-- Card Footer -->
                <div class="card-footer">
                    <button 
                        class="start-btn"
                        (click)="showCasesDialog(form)"
                        [disabled]="!form.cases || form.cases.length === 0">
                        <span>Mulai Quiz</span>
                        <i class="pi pi-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <ng-template #noQuizzes>
        <div class="empty-state">
            <div class="empty-icon">
                <i class="pi pi-inbox"></i>
            </div>
            <h3 class="empty-title">Belum Ada Quiz</h3>
            <p class="empty-description">Quiz akan tersedia segera. Silakan cek kembali nanti.</p>
        </div>
    </ng-template>

    <!-- Dialog untuk memilih kasus -->
    <p-dialog 
        header="Pilih Kasus Quiz" 
        [(visible)]="showDialog" 
        [modal]="true" 
        [style]="{ width: '600px', maxWidth: '90vw' }" 
        [draggable]="false" 
        [resizable]="false"
        styleClass="case-selection-dialog">
        
        <div *ngIf="selectedCasesForm" class="dialog-content">
            <!-- Dialog Header Info -->
            <div class="dialog-header-info">
                <div class="quiz-info">
                    <h4 class="quiz-name">{{ selectedCasesForm.name }}</h4>
                    <p class="quiz-subtitle">Pilih salah satu kasus untuk memulai quiz</p>
                </div>
                <div class="quiz-stats-mini">
                    <span class="stat-mini">
                        <i class="pi pi-file-edit"></i>
                        {{ selectedCasesForm.cases?.length || 0 }} Kasus
                    </span>
                </div>
            </div>
            
            <!-- Cases List -->
            <div *ngIf="selectedCasesForm.cases?.length > 0; else noCases" class="cases-container">
                <div class="case-option" 
                     *ngFor="let c of selectedCasesForm.cases; let idx = index"
                     [class.selected]="selectedCase === c"
                     (click)="selectCase(c)">
                    <div class="case-content">
                        <div class="case-radio">
                            <p-radiobutton
                                name="caseRadio"
                                [value]="c"
                                [(ngModel)]="selectedCase"
                                [inputId]="'case'+idx" />
                        </div>
                        <div class="case-details">
                            <label [for]="'case'+idx" class="case-title">
                                {{ c.name }}
                            </label>
                            <p class="case-description" *ngIf="c.description">
                                {{ c.description }}
                            </p>
                            <div class="case-meta" *ngIf="c.difficulty || c.duration">
                                <span class="meta-tag" *ngIf="c.difficulty">{{ c.difficulty }}</span>
                                <span class="meta-tag" *ngIf="c.duration">{{ c.duration }} menit</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- No Cases State -->
            <ng-template #noCases>
                <div class="no-cases-state">
                    <div class="no-cases-icon">
                        <i class="pi pi-exclamation-triangle"></i>
                    </div>
                    <h5 class="no-cases-title">Tidak Ada Kasus</h5>
                    <p class="no-cases-description">Quiz ini belum memiliki kasus yang tersedia.</p>
                </div>
            </ng-template>
        </div>
        
        <!-- Dialog Footer -->
        <ng-template pTemplate="footer">
            <div class="dialog-footer">
                <button class="btn-secondary" (click)="showDialog = false">
                    <i class="pi pi-times"></i>
                    <span>Batal</span>
                </button>
                <button 
                    class="btn-primary"
                    [disabled]="!selectedCase"
                    (click)="startQuiz(selectedCase)">
                    <span>Mulai Quiz</span>
                    <i class="pi pi-arrow-right"></i>
                </button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Dialog info quiz -->
    <p-dialog 
        header="Informasi Quiz" 
        [(visible)]="showInfoDialog" 
        [modal]="true" 
        [style]="{ width: '500px', maxWidth: '90vw' }"
        styleClass="quiz-info-dialog">
        
        <div *ngIf="selectedInfoForm" class="info-content">
            <div class="info-header">
                <h4 class="info-title">{{ selectedInfoForm.name }}</h4>
            </div>
            
            <div class="info-details">
                <div class="info-item">
                    <div class="info-icon">
                        <i class="pi pi-align-left"></i>
                    </div>
                    <div class="info-text">
                        <label>Deskripsi</label>
                        <p>{{ selectedInfoForm.description || 'Tidak ada deskripsi tersedia.' }}</p>
                    </div>
                </div>
                
                <div class="info-item">
                    <div class="info-icon">
                        <i class="pi pi-file-edit"></i>
                    </div>
                    <div class="info-text">
                        <label>Jumlah Kasus</label>
                        <p>{{ selectedInfoForm.cases?.length || 0 }} kasus tersedia</p>
                    </div>
                </div>
                
                <div class="info-item">
                    <div class="info-icon">
                        <i class="pi pi-clock"></i>
                    </div>
                    <div class="info-text">
                        <label>Estimasi Waktu</label>
                        <p>{{ getEstimatedTime(selectedInfoForm.cases?.length || 0) }}</p>
                    </div>
                </div>
                
                <div class="info-item">
                    <div class="info-icon">
                        <i class="pi pi-calendar"></i>
                    </div>
                    <div class="info-text">
                        <label>Dibuat</label>
                        <p>{{ selectedInfoForm.created_at | date:'dd MMMM yyyy, HH:mm' }}</p>
                    </div>
                </div>
            </div>
        </div>
        
        <ng-template pTemplate="footer">
            <div class="dialog-footer">
                <button class="btn-secondary" (click)="showInfoDialog = false">
                    <i class="pi pi-times"></i>
                    <span>Tutup</span>
                </button>
            </div>
        </ng-template>
    </p-dialog>
    `,
    styles: [`
        :host {
            display: block;
            padding: 2rem;
            background: #f8fafc;
            min-height: 100vh;
        }

        /* Header Styles */
        .quiz-header {
            margin-bottom: 1rem;
        }

        .title-icon {
            width: 4rem;
            height: 4rem;
            background: linear-gradient(90deg, #2162DF 100%, #558BED 0%);
            border-radius: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
        }

        .header-stats {
            margin-top: 1rem;
        }

        .stats-card {
            background: white;
            padding: 1.5rem 2rem;
            border-radius: 1rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            text-align: center;
            border: 1px solid #e2e8f0;
        }

        .stat-number {
            display: block;
            font-size: 2rem;
            font-weight: 700;
            color: #1e293b;
            line-height: 1;
        }

        .stat-label {
            display: block;
            font-size: 0.875rem;
            color: #64748b;
            margin-top: 0.5rem;
        }

        /* Quiz Grid */
        .quiz-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
            gap: 2rem;
        }

        .quiz-item {
            display: flex;
        }

        .quiz-card {
            background: white;
            border-radius: 1.25rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            border: 1px solid #e2e8f0;
            overflow: hidden;
            transition: all 0.3s ease;
            display: flex;
            flex-direction: column;
            width: 100%;
            position: relative;
        }

        .quiz-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        .quiz-card.variant-1::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #ED4141 0%, #f65a5aff 100%);
        }

        .quiz-card.variant-2::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #429AED 0%, #287ac7ff 100%);
        }

        .quiz-card.variant-3::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
        }

        /* Card Header */
        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: start;
            padding: 1.5rem 1.5rem 0;
        }

        .quiz-badge {
            width: 3rem;
            height: 3rem;
            background: #f1f5f9;
            border-radius: 0.75rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #475569;
            font-size: 1.25rem;
        }

        .card-actions {
            display: flex;
            gap: 0.5rem;
        }

        .action-btn {
            width: 2.5rem;
            height: 2.5rem;
            border: none;
            background: #f1f5f9;
            border-radius: 0.5rem;
            color: #64748b;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .action-btn:hover {
            background: #e2e8f0;
            color: #475569;
        }

        /* Card Content */
        .card-content {
            padding: 1.5rem;
            flex: 1;
        }

        .quiz-title {
            font-size: 1.25rem;
            font-weight: 900;
            color: #1e293b;
            margin: 0 0 0.75rem 0;
            line-height: 1.3;
        }

        .quiz-description {
            color: #64748b;
            font-size: 0.875rem;
            line-height: 1.5;
            margin: 0 0 1.5rem 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        .quiz-meta {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
        }

        .meta-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #64748b;
            font-size: 0.875rem;
        }

        .meta-item i {
            color: #94a3b8;
            font-size: 0.75rem;
        }

        /* Progress Section */
        .progress-section {
            margin-top: 1rem;
            padding: 1rem;
            background: #f8fafc;
            border-radius: 0.75rem;
        }

        .progress-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
        }

        .progress-label {
            font-size: 0.875rem;
            color: #64748b;
        }

        .progress-value {
            font-size: 0.875rem;
            font-weight: 600;
            color: #1e293b;
        }

        .progress-bar {
            height: 6px;
            background: #e2e8f0;
            border-radius: 3px;
            overflow: hidden;
        }

        .progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #10b981 0%, #059669 100%);
            transition: width 0.3s ease;
        }

        /* Card Footer */
        .card-footer {
            padding: 0 1.5rem 1.5rem;
        }

        .start-btn {
            width: 100%;
            padding: 0.75rem 1rem;
            background: black;
            color: white;
            border: none;
            border-radius: 0.75rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
        }

        .start-btn:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }

        .start-btn:disabled {
            background: #94a3b8;
            cursor: not-allowed;
        }

        /* Empty State */
        .empty-state {
            text-align: center;
            padding: 4rem 2rem;
            background: white;
            border-radius: 1.25rem;
            border: 1px solid #e2e8f0;
        }

        .empty-icon {
            font-size: 4rem;
            color: #cbd5e1;
            margin-bottom: 1.5rem;
        }

        .empty-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #475569;
            margin: 0 0 0.5rem 0;
        }

        .empty-description {
            color: #64748b;
            margin: 0;
        }

        /* Dialog Styles */
        ::ng-deep .case-selection-dialog .p-dialog-content,
        ::ng-deep .quiz-info-dialog .p-dialog-content {
            padding: 0;
        }

        .dialog-content {
            padding: 1.5rem;
        }

        .dialog-header-info {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 2rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #e2e8f0;
        }

        .quiz-name {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1e293b;
            margin: 0 0 0.5rem 0;
        }

        .quiz-subtitle {
            color: #64748b;
            margin: 0;
            font-size: 0.875rem;
        }

        .quiz-stats-mini {
            background: #f1f5f9;
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
        }

        .stat-mini {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #475569;
            font-size: 0.875rem;
            font-weight: 500;
        }

        .stat-mini i {
            color: #64748b;
        }

        /* Cases Container */
        .cases-container {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .case-option {
            border: 2px solid #e2e8f0;
            border-radius: 0.75rem;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .case-option:hover {
            border-color: #c7d2fe;
            background: #f8fafc;
        }

        .case-option.selected {
            border-color: #667eea;
            background: #f0f4ff;
        }

        .case-content {
            display: flex;
            align-items: flex-start;
            gap: 1rem;
        }

        .case-radio {
            margin-top: 0.25rem;
        }

        .case-details {
            flex: 1;
        }

        .case-title {
            display: block;
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 0.5rem;
            cursor: pointer;
        }

        .case-description {
            color: #64748b;
            font-size: 0.875rem;
            margin: 0 0 0.75rem 0;
            line-height: 1.4;
        }

        .case-meta {
            display: flex;
            gap: 0.5rem;
        }

        .meta-tag {
            background: #e2e8f0;
            color: #475569;
            padding: 0.25rem 0.5rem;
            border-radius: 0.375rem;
            font-size: 0.75rem;
            font-weight: 500;
        }

        /* No Cases State */
        .no-cases-state {
            text-align: center;
            padding: 3rem 1rem;
        }

        .no-cases-icon {
            font-size: 3rem;
            color: #fbbf24;
            margin-bottom: 1rem;
        }

        .no-cases-title {
            font-size: 1.125rem;
            font-weight: 600;
            color: #475569;
            margin: 0 0 0.5rem 0;
        }

        .no-cases-description {
            color: #64748b;
            margin: 0;
        }

        /* Info Content */
        .info-content {
            padding: 1.5rem;
        }

        .info-header {
            margin-bottom: 2rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #e2e8f0;
        }

        .info-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1e293b;
            margin: 0;
        }

        .info-details {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
        }

        .info-item {
            display: flex;
            align-items: flex-start;
            gap: 1rem;
        }

        .info-icon {
            width: 2.5rem;
            height: 2.5rem;
            background: #f1f5f9;
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #64748b;
            flex-shrink: 0;
        }

        .info-text {
            flex: 1;
        }

        .info-text label {
            display: block;
            font-weight: 500;
            color: #475569;
            margin-bottom: 0.25rem;
            font-size: 0.875rem;
        }

        .info-text p {
            color: #1e293b;
            margin: 0;
            line-height: 1.5;
        }

        /* Dialog Footer */
        .dialog-footer {
            display: flex;
            justify-content: flex-end;
            gap: 1rem;
            padding: 1rem 1.5rem;
            border-top: 1px solid #e2e8f0;
            background: #f8fafc;
        }

        .btn-secondary,
        .btn-primary {
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            font-weight: 500;
            border: none;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .btn-secondary {
            background: white;
            color: #64748b;
            border: 1px solid #d1d5db;
        }

        .btn-secondary:hover {
            background: #f9fafb;
            color: #374151;
        }

        .btn-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
        }

        .btn-primary:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }

        .btn-primary:disabled {
            background: #94a3b8;
            cursor: not-allowed;
        }

        /* Responsive */
        @media (max-width: 768px) {
            :host {
                padding: 1rem;
            }

            .quiz-grid {
                grid-template-columns: 1fr;
                gap: 1.5rem;
            }

            .header-stats {
                margin-top: 1.5rem;
            }

            .quiz-header .flex {
                flex-direction: column;
                align-items: flex-start;
            }

            .dialog-header-info {
                flex-direction: column;
                gap: 1rem;
            }

            .case-content {
                flex-direction: column;
                gap: 0.75rem;
            }

            .case-radio {
                margin-top: 0;
            }
        }
    `]
})
export class Quiz implements OnInit {
    forms: any[] = [];
    showDialog: boolean = false;
    showInfoDialog: boolean = false;
    selectedCasesForm: any = null;
    selectedInfoForm: any = null;
    selectedCase: any = null;

    colorVariants = [
        'variant-1',
        'variant-2', 
        'variant-3'
    ];

    constructor(
        private userService: UserService,
        private router: Router
    ) { }

    ngOnInit() {
        this.initApi();
        this.clearPreviousQuizData();
    }

    async initApi(): Promise<void> {
        try {
            const formFieldRes = await this.userService.getFormField();
            const formCasesRes = await this.userService.getFormCases();
            const allCases = formCasesRes.data;

            this.forms = formFieldRes.data.map((form: any) => {
                if (typeof form.fields === 'string') {
                    try {
                        form.fields = JSON.parse(form.fields);
                    } catch (error) {
                        console.error('Failed to parse fields:', error);
                        form.fields = [];
                    }
                }
                form.cases = allCases.filter((item: any) => item.form_id === form.id);
                return form;
            });
        } catch (error) {
            console.error('Failed to fetch quiz data:', error);
        }
    }

    clearPreviousQuizData() {
        localStorage.removeItem('selected_case');
        localStorage.removeItem('question_history_list');
        localStorage.removeItem('last_form_detail_id');
        localStorage.removeItem('last_form_detail_data');
        localStorage.removeItem('excluded_form_detail_ids');
        localStorage.removeItem('current_question_index');
    }

    showCasesDialog(form: any) {
        this.selectedCasesForm = form;
        this.selectedCase = null;
        this.showDialog = true;
    }

    showQuizInfo(form: any) {
        this.selectedInfoForm = form;
        this.showInfoDialog = true;
    }

    previewQuiz(form: any) {
        // Implementasi preview quiz
        console.log('Preview quiz:', form);
        // Bisa redirect ke halaman preview atau buka modal preview
    }

    selectCase(caseItem: any) {
        this.selectedCase = caseItem;
    }

    startQuiz(selectedCase: any) {
        // Simpan case ke localStorage
        localStorage.setItem('selected_case', JSON.stringify(selectedCase));
        // Redirect ke halaman answer
        this.showDialog = false;
        this.router.navigate(['/app/osce/form/answer']);
    }

    onDialogHide() {
        this.selectedCasesForm = null;
        this.selectedCase = null;
    }

    getCardClass(i: number): string {
        return this.colorVariants[i % this.colorVariants.length];
    }

    getIcon(i: number): string {
        const images = [
            'icons/Quiz Icon.png',
            'icons/Quiz Icon (1).png', 
            'icons/Quiz Icon (2).png'
        ];
        return images[i % images.length];
    }

    getIconClass(i: number): string {
        return 'text-white';
    }

    getEstimatedTime(caseCount: number): string {
        const minutes = caseCount * 5; // Asumsi 5 menit per kasus
        if (minutes < 60) {
            return `${minutes} menit`;
        } else {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return remainingMinutes > 0 ? `${hours}j ${remainingMinutes}m` : `${hours} jam`;
        }
    }

    getQuizProgress(formId: string): number {
        // Implementasi untuk mendapatkan progress quiz dari localStorage atau API
        const progressKey = `quiz_progress_${formId}`;
        const progress = localStorage.getItem(progressKey);
        return progress ? parseInt(progress) : 0;
    }
}
